import { createFileRoute, redirect } from "@tanstack/react-router";

import { ApplyPage } from "@/features/applications/apply-page";
import {
  caseDetailQueryOptions,
  myApplicationForCaseQueryOptions,
} from "@/features/cases/queries";
import { STATIC_LABELS } from "@/lib/nav-registry";

/**
 * ロールガードは親 layout (`member/route.tsx`) が MEMBER 限定。
 *
 * loader で応募可否を事前判定し、応募不可（応募済み / 非公開 / 募集終了 等）なら
 * フォームに入らせず案件詳細へリダイレクトする（送信時に 409/422 で初めて気づく UX を防ぐ）。
 * 応募可否ロジックは member-case-detail-page の canApply と一致させる。
 * caseDetail は親 `member/$id/route.tsx` が prefetch 済みのため ensureQueryData は cache hit する。
 */
export const Route = createFileRoute("/_authenticated/member/$id/apply")({
  staticData: { crumb: { label: STATIC_LABELS.memberApply } },
  loader: async ({ context, params }) => {
    const { id } = params;
    const [useCase, myApplication] = await Promise.all([
      context.queryClient.ensureQueryData(caseDetailQueryOptions(id)),
      context.queryClient.ensureQueryData(myApplicationForCaseQueryOptions(id)),
    ]);
    const isBlocked = myApplication?.status === "AUDIT_BLOCKED";
    // 会員に届く案件は可視ステータスのみ。応募可能なのは募集中(OPEN)。
    const canApply =
      useCase.status === "OPEN" && (!myApplication || isBlocked);
    if (!canApply) {
      // 詳細ページが「応募できない理由 / 応募済み」を表示するのでそこへ戻す。
      throw redirect({ to: "/member/$id", params: { id } });
    }
  },
  component: ApplyPage,
});
